import { pathToPermissionCode } from './permissions';

/**
 * Keep items the user is allowed to see.
 * - If item.perm exists → use it
 * - else derive from item.path's first segment (e.g. /orders/123 → orders:access)
 * - Parent stays visible if ANY child is visible (or parent itself is allowed)
 * - Admin sees everything
 */
export default function filterMenuByPermissions(menuItems, userPerms = [], isAdmin = false) {
  const allowed = (item) => {
    if (isAdmin) return true;
    const code =
      item.perm ||
      (item.path ? pathToPermissionCode(item.path) : null);
    return !code || userPerms.includes(code);
  };

  const walk = (items) =>
    items
      .map((item) => {
        if (item.is_header || item.is_divider) return item;

        // handle children first
        const children = Array.isArray(item.children) ? walk(item.children) : null;

        // keep parent if: any child is visible OR parent itself allowed
        if ((children && children.length) || allowed(item)) {
          return children ? { ...item, children } : item;
        }
        return null;
      })
      .filter(Boolean);

  return walk(menuItems);
}
